import type { Filter } from '@/app/common/filters/core/filtersTypes';
import type { TranslationFunction } from '@/app/components/translations/Translation.tsx';
import type { Localization } from '@/app/components/search/common/Localization.ts';
import { priceRangeLabel } from '@/app/common/filters/types/range/priceRangeLabel.ts';

export const FilterRangePill = (filter: Filter, t?: TranslationFunction, localization?: Localization): string[] => [
  priceRangeLabel(filter, { t, localization }),
];
